module.exports = __webpack_public_path__ + "static/media/18.b7dcbdb0.png";